// extracted by mini-css-extract-plugin
export default {"start":"bookStart_start__ejYyf","wrap":"bookStart_wrap__ls2ig","button":"bookStart_button__ofNa1","show":"bookStart_show__0ILHb","hide":"bookStart_hide__ASTnu"};